// Qəbz (receipt) çapı — POS rejimində birbaşa termal çek aparatından.
//
// Cloud rejimində qəbz brauzerin `window.print()` dialoqu ilə çap olunur.
// POS (Electron) rejimində isə qəbz birbaşa pos_local-a qoşulu termal printerdən
// çıxmalıdır — brauzer dialoqu YOX. Bunu pos_local `POST /v1/orders/:id/print/receipt`
// endpoint-i ilə edirik.
//
// İstifadə (çağıran komponentdə, mövcud brauzer-çap məntiqindən ƏVVƏL):
//   if (await printReceiptThermal(orderId)) return;   // POS → termal, brauzer açma
//   ...köhnə window.print() məntiqi (yalnız cloud-da işləyəcək)...

import { POS_ENABLED } from './config';
import { posRequest } from './posClient';

/**
 * POS rejimində qəbzi termal çek aparatından çap edir.
 *
 * @returns true  → POS rejimi, çap çek aparatına göndərildi (brauzer çapı ETMƏ).
 *          false → cloud rejimi, çağıran köhnə brauzer çapına davam etməlidir.
 * @throws  POS rejimində sifariş yoxdursa və ya çap göndərilə bilməsə
 *          (çağıran try/catch ilə istifadəçiyə bildirir).
 */
export async function printReceiptThermal(
  orderId: string | number | null | undefined,
): Promise<boolean> {
  if (!POS_ENABLED) return false; // cloud → brauzer çapı (köhnə davranış)

  if (orderId == null || orderId === '') {
    throw new Error('Qəbz üçün açıq sifariş tapılmadı');
  }

  const res = await posRequest({
    method: 'POST',
    path: `/v1/orders/${orderId}/print/receipt`,
    body: {},
  });

  if (!res.ok) {
    throw new Error(res.error?.message || 'Çek aparatına çap göndərilə bilmədi');
  }
  return true; // termal çap olundu
}
